import React from "react";
import { mergeStyleSets, nuOrderTheme as theme, Icon } from "@nuorder/components";

interface IDialogTitle {
    iconName?: string;
    iconColor?: string;
    mainTitle: string;
    subTitle?: string;
    onBack?: () => void;
}
export const DialogTitle: React.FunctionComponent<IDialogTitle> = ({
    iconName,
    iconColor,
    mainTitle,
    subTitle,
    onBack,
}) => {
    const classes = React.useMemo(
        () =>
            mergeStyleSets({
                titleContainer: {
                    hight: "24px",
                    display: "flex",
                },
                titleTextBox: {
                    fontSize: "16px",
                    lineHeight: "24px",
                    marginLeft: iconName ? "16px" : 0,
                    color: theme.palette.black,
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    marginRight: "25px",
                },
                titleName: {
                    fontSize: "14px",
                    color: theme.palette.greyDarker,
                },
                titleIcon: {
                    " svg": [
                        {
                            fill: iconColor || theme.palette.greyDarker,
                        },
                        onBack && {
                            fill: theme.palette.black,
                        },
                    ],
                    "&:hover": [
                        onBack && {
                            cursor: "pointer",
                        },
                    ],
                },
            }),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [onBack, iconName]
    );

    const handleGoBack = React.useCallback(() => {
        onBack?.();
    }, [onBack]);

    return (
        <div className={classes.titleContainer}>
            {!!iconName && <Icon iconName={iconName || ""} className={classes.titleIcon} onClick={handleGoBack} />}
            <div className={classes.titleTextBox}>
                {mainTitle} {subTitle && <span className={classes.titleName}> - {subTitle}</span>}
            </div>
        </div>
    );
};
